import styled from 'styled-components';
import { device, color, Common } from '@stockbit/ui';

const { Flex } = Common;

export const InvestementContainer = styled(Flex)`
  position: relative;

  &:before {
    height: 0px;
    width: 80%;
    border-bottom: 2px dashed ${color.midgray};
    content: '';
    position: absolute;
    top: 46px;
    left: 10%;
    @media ${device.tablet} {
      border-bottom: 4px dashed ${color.midgray};
      top: 76px;
      left: 20%;
      width: 60%;
    }
  }
`;

export const InvestStep = styled(Flex).attrs({ justify: 'flex-end', align: 'center', direction: 'column' })`
  text-align: center;
  position: relative;
  width: calc(100% / 3);
  margin: 25px 10px;
  padding: 5px;
  background: #fff;

  @media ${device.tablet} {
    background: transparent;

    p {
      font-size: 19px;
    }
  }

  img {
    max-width: 100%;
    width: 50px;
    height: 50px;
    object-fit: contain;
    @media ${device.tablet} {
      width: 120px;
      height: 120px;
      margin-bottom: 20px;
      background: ${color.light};
    }
  }
`;
